<template>
    <div class="page">
        <div class="header">
            <img src="../assets/images/loading_top.jpg" :style="'transform: scale('+ topScale +'); -webkit-transform: scale(' + topScale + ')'">
        </div>
        <div class="content" :style="'transform: scale('+ scale +'); -webkit-transform: scale(' + scale + ')'">
            <div class="door door-left">
                <img src="../assets/images/door.png" :style="'left:' + left + '%; top:' + leftTop + '%'">
            </div>
            <div class="door door-right">
                <img src="../assets/images/door.png" :style="'right:' + right + '%; top:' + rightTop + '%'">
            </div>
        </div>
    </div>
</template>

<script>
    import { Image } from 'vant';

    export default {
        name: 'Loading',
        components: {
            [Image.name]: Image
        },
        data () {
            return {
                left: -2,
                right: 0,
                leftTop: -10,
                rightTop: -6,
                topScale: 1,
                scale: 1
            }
        },
        methods: {

        },
        created () {
            this.$emit('logo', false);
            this.$emit('prev', false);

            let timeOut = 12;
            let interval = setInterval(() => {
                timeOut--;
                this.left -= 2;
                this.right -= 2;
                this.topScale += 0.001;
                this.scale += 0.02;
                this.leftTop += 0.12;
                this.rightTop -= 0.12;

                if (timeOut <= 0) {
                    clearInterval(interval);
                    this.$router.push('/guide');
                }
            }, 100);
        }
    }
</script>

<style lang="scss" scoped>
    .header {
        position: relative;
        z-index: 101;
        img {
            width: 100%;
        }
    }

    .content {
        position: absolute;
        width: 100%;
        height: 100%;
        overflow-y: auto;
        background: url('../assets/images/loading_bottom.jpg') no-repeat center top;
        background-size: cover;
        margin-top: -16%;

        .door-left img {
            position: absolute;
            width: 52%;
            height: 78.5%;
            opacity: 0.6;
            -webkit-transform: skew(0deg, 4deg);
            -moz-transform: skew(0deg, 4deg);
            -ms-transform: skew(0deg, 4deg);
            -o-transform: skew(0deg, 4deg);
            transform: skew(0deg, 4deg);
        }

        .door-right img {
            position: absolute;
            width: 50%;
            height: 71.5%;
            opacity: 0.6;
            -webkit-transform: skew(0deg, 4deg);
            -moz-transform: skew(0deg, 4deg);
            -ms-transform: skew(0deg, 4deg);
            -o-transform: skew(0deg, 4deg);
            transform: skew(0deg, 4deg);
        }

    }
</style>
